import React from 'react';
import { campaign } from '../config/campaign';

const AnnouncementBar: React.FC = () => {
  if (!campaign.showAnnouncementBar) {
    return null;
  }

  const repeatedAnnouncement = Array.from({ length: 4 }, () => campaign.announcementText);

  return (
    <div
      className="campaign-announcement-bar sticky top-0 z-50 h-10 w-full overflow-hidden border-b border-[#E2C58A]/35 bg-[#24102D]/95 text-[#FFF9F2] shadow-[0_4px_22px_rgba(201,164,94,0.16)] backdrop-blur-md md:h-11"
      style={{ backgroundImage: campaign.gradientColors.announcement }}
    >
      <div className="campaign-announcement-shimmer" aria-hidden="true" />
      <div className="campaign-announcement-track flex h-full items-center whitespace-nowrap">
        {repeatedAnnouncement.map((message, index) => (
          <span
            key={`${message}-${index}`}
            className="mx-8 text-xs font-semibold uppercase tracking-[0.2em] text-[#E2C58A] md:text-sm"
          >
            {message}
          </span>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementBar;
